import view from './view.html';

/* @ngInject */
export default function () {
	return {
		replace:                    true,
		template:                   view,
		scope:                      {
			element:     '=',
			getResponse: '&',
		},
		controller: /* @ngInject */ ($scope) => {
			$scope.refreshResponseValue = (value) => {
				if (typeof value === 'undefined') {
					return;
				}

				$scope.element.responseValue = value;
			};

			$scope.$watch('element.value.value', (newValue) => {
				$scope.refreshResponseValue(newValue);
			}, true);

			if ($scope.getResponse && typeof $scope.getResponse === 'function' && typeof $scope.getResponse() === 'function') {
				const response = $scope.getResponse()($scope.element);

				if (response) {
					$scope.refreshResponseValue(response.value.value);
				}
			} else {
				$scope.refreshResponseValue($scope.element.value.value);
			}
		},
		link:                       (scope, element, attrs) => {

		},
	};
};


// WEBPACK FOOTER //
// ./src/js/directives/formElements/inputMultiline/index.js